import React, { useState } from "react";
import SchoolClubCreationForm from "./SchoolClubCreationForm";
import TourCreationForm from "./TourCreationForm";
import EventCreationForm from "./EventCreationForm";
import FacilityRentalCreationForm from "./FacilityRentalCreationForm";
import AfterSchoolClubCreationForm from "./AfterSchoolClubCreationForm";

function ActivitySetup() {
  const [selectedForm, setSelectedForm] = useState("Event");

  const handleChange = (event) => {
    setSelectedForm(event.target.value);
  };

  const renderForm = () => {
    switch (selectedForm) {
      // case "SchoolClub":
      //   return <SchoolClubCreationForm />;

      // case "Tour":
      //   return <TourCreationForm />;

      case "Event":
        return <EventCreationForm />;

      // case "FacilityRental":
      //   return <FacilityRentalCreationForm />;

      // case "AfterSchoolClub":
      //   return <AfterSchoolClubCreationForm />;

      default:
        return null;
    }
  };

  return (
    <div>
      <div className="page-header d-flex">
        <h2 className="page-heading mb-2 fs-7">Activity Setup</h2>
      </div>

      <select
        className="form-select mb-3"
        style={{ width: "200px" }}
        onChange={handleChange}
      >
        {/* <option value="">Select a form</option> */}
        <option value="Event">Event</option>
        {/* <option value="SchoolClub">School Club</option>
        <option value="Tour">Tour</option>
        <option value="FacilityRental">Facility Rental</option>
        <option value="AfterSchoolClub">After School Club</option> */}
      </select>

      <div>{renderForm()}</div>
    </div>
  );
}

export default ActivitySetup;
